const ARABIC_INDIC = '٠١٢٣٤٥٦٧٨٩'
const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'

function isArabicLetter(code: number): boolean {
  return (code >= 0x0621 && code <= 0x064a) || (code >= 0x0671 && code <= 0x06d3)
}

function isDecimalSeparator(ch: string, code: number): boolean {
  return (
    ch === '.' ||
    ch === ',' ||
    ch === '·' ||
    code === 0x066b || // ٫ Arabic decimal separator
    code === 0x060c || // ، Arabic comma
    code === 0x06d4 // ۔ Arabic full stop
  )
}

/**
 * Some Android keyboards (Samsung + Arabic) send an Arabic letter — often ل —
 * or ٫ instead of a decimal point. `type="number"` then drops the key.
 * Keep one ASCII dot and ASCII digits so 5.2 can be typed on those devices.
 */
export function normalizeDecimalDraft(raw: string): string {
  let out = ''
  let sawDot = false
  for (const ch of raw) {
    const indic = ARABIC_INDIC.indexOf(ch)
    if (indic >= 0) {
      out += String(indic)
      continue
    }
    const persian = PERSIAN_DIGITS.indexOf(ch)
    if (persian >= 0) {
      out += String(persian)
      continue
    }
    const code = ch.charCodeAt(0)
    if (ch >= '0' && ch <= '9') {
      out += ch
      continue
    }
    if (code === 0x066c || ch === ' ' || ch === '\u00a0') continue
    if (isDecimalSeparator(ch, code) || isArabicLetter(code)) {
      if (!sawDot) {
        out += '.'
        sawDot = true
      }
    }
  }
  return out
}

/** Parse a draft. "5." is 5 so a trailing separator can stay on screen. */
export function parseDecimalDraft(raw: string): number | null {
  const text = raw.trim()
  if (text === '' || text === '.' || text === '-' || text === '-.') return null
  const n = Number(text)
  return Number.isFinite(n) ? n : null
}
